import { SET_USER_FILTER_STATE } from '../../constants/filter';

export const setUserMetricFilter = (userId, reportId, orgUuid,
  filterType, value) => {
  const userIdentifier = `${userId}#${reportId}#${orgUuid}`;
  return ({ type: SET_USER_FILTER_STATE, userIdentifier, filterType, value });
};

export const setUserDateFilter = (userId, reportId, orgUuid,
  filterType, value) => {
  const userIdentifier = `${userId}#${reportId}#${orgUuid}`;
  return ({ type: SET_USER_FILTER_STATE, userIdentifier, filterType, value });
};
